import React, { useContext } from "react";
import { SITE_V3 } from "@config/config";
import useTrackingViewItem from "@hooks/useTrackingViewItem";
import { AuthContext } from "@context/AuthContext";
import BookSession from "@components/Bookings/BookSession";
import LayoutV3 from "@components/V3/Layout";
import V2V3BookSession from "@components/V3/V3BookSession";
import Layout from "@components/Wrappers/Layout";

const TicketPurchasePage = () => {
    const { siteVersion } = useContext(AuthContext);
    const LayoutComponent = siteVersion === SITE_V3 ? LayoutV3 : Layout;

    // Google Analytics tracking for viewing items
    useTrackingViewItem();

    return (
        <LayoutComponent>
            {siteVersion === SITE_V3 ? <V2V3BookSession /> : <BookSession />}
        </LayoutComponent>
    );
};

export default TicketPurchasePage;
